import { useEffect } from 'react';

const TeatroRedirect = () => {
  useEffect(() => {
    // Redirect to the Teatro URL immediately when component mounts
    window.location.href = 'https://teatro-pass-asteroids.vercel.app/shows';
  }, []);

  // Show loading message briefly before redirect
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      fontSize: '18px',
      color: '#333'
    }}>
      Redirecting to Teatro Pass...
    </div>
  );
};

export default TeatroRedirect; 